module.exports = __webpack_public_path__ + "static/img/bg.c8645f16.png";